<script setup lang="ts">

import { GetTheAppButton } from '@components/GetTheAppButton';

const chunkSize = 12; // Works best if partner count is evenly divisible by this number 

const partners = [
    '/images/Partners/adidas-001.png',
    '/images/Partners/booking-001.png',
    '/images/Partners/suttons-001.png', 
    '/images/Partners/bing-lee-001.png',
    '/images/Partners/bws-001.png',
    '/images/Partners/chemist-warehouse-001.png',
    '/images/Partners/cotton-on-001.png',
    '/images/Partners/crocs-001.png',
    '/images/Partners/dusk-001.png',
    '/images/Partners/ecco-001.png',
    '/images/Partners/endota-spa-001.png',
    '/images/Partners/freely-001.png',
    '/images/Partners/glue-store-001.png',
    '/images/Partners/harris-scarfe-001.png',
    '/images/Partners/harvey-norman-001.png',
    '/images/Partners/hello-fresh-001.png',
    '/images/Partners/hertz-001.png',
    '/images/Partners/jd-sport-001.png',
    '/images/Partners/kathmandu-001.png',
    '/images/Partners/lego-001.png',
    '/images/Partners/menu-log-001.png',
    '/images/Partners/milkrun-001.png',
    '/images/Partners/national-windscreen-001.png',
    '/images/Partners/petbarn-001.png',
    '/images/Partners/schmick-001.png',
    '/images/Partners/sony-001.png',
    '/images/Partners/spec-savers-001.png',
    '/images/Partners/star-carwash-001.png',
    '/images/Partners/t2-001.png',
    '/images/Partners/the-body-shop-001.png',
    '/images/Partners/typo-001.png',
    '/images/Partners/tyroola-001.png',
    '/images/Partners/uber-eats-001.png',
    '/images/Partners/virgin-aus-001.png',
    '/images/Partners/vista-print-001.png',
    '/images/Partners/vodafone-001.png',
];

const groups = partners.reduce( ( all: any, one:any, i ) => 
{
    const chunk = Math.floor( i / chunkSize ); 
    all[ chunk ] = [].concat( (all[ chunk ] || [] ), one ); 
    return all
}, [] );

</script>

<template>

    <div class="text-center tracking-wider pt-16 pb-8 mt-8 md:mt-16">

        <div class="max-w-5xl mx-auto px-4">
            <h1 class="text-5xl font-semibold">
                Our <span class="text-primary-600 font-bold uppercase">Rewards</span> Partners
            </h1>
            <p class="mt-3 font-lg">
                We have a huge range of automotive and lifestyle partners to bring you exclusive offers and savings
            </p>

            <v-carousel class="my-16 !h-[300px] md:!h-[200px]"
                        :show-arrows="false"
                        hide-delimiters
                        cycle>
                <v-carousel-item v-for="group in groups">
                    <div class="w-full grid grid-cols-4 md:grid-cols-6 items-center justify-between gap-y-8 px-2 md:px-12 lg:px-20">
                        <div v-for="partner in group" 
                             class="flex items-center justify-center">
                            <img :src="partner" class="w-1/2 rounded-[8px] overflow-hidden" />
                        </div>
                    </div>
                </v-carousel-item>
            </v-carousel>

            <div class="rounded-[3rem] p-16 bg-[#3e3c94] text-white text-center">
                <h1 class="text-3xl font-semibold mb-4">Want to see 1,000's more reward partners?</h1>
                <GetTheAppButton />
            </div>

        </div>

    </div>

</template>